<template>
  <div class="content" :style="`height: ${curHeight}`">
    <div class="content-box">
      <div class="box" @mouseleave.stop="mouseout">
        <div class="box-item">
          <img src="../../../assets/images/icon_visa_table_down.png" />
          <p>{{resource["RES94443CB61B253F3"]}}</p>
          <div class="item-item">
            <p>
              <span v-for="item in tableDownloadInfo" :key="item.moduleCode" class="Space" style="margin: 0 0.3em" @click='navDetailByModuleCode("表格下载", item)' @mouseenter="mouseOver(item, '730px', true)">{{ item.moduleName }}</span>
            </p>
          </div>
        </div>
        <div v-for="item in tableDownloadInfo" :key="item.moduleCode">
          <div :style="
              open &&
              `overflow-y: scroll` && { height: 'auto', minHeight: '570px' }
            " class="hover-content hover-download" v-if="mouseModuleCode === item.moduleCode" ref="QAPaper">
            <div class="hover-box" v-bind:style="{
                '--beforeLeft': 143 + 'px',
                '--afterLeft': 142 + 'px',
              }">
              <div class="subtitle" style="font-size: 20px;
                  padding-bottom: 10px;
                  padding-left: 23px;
                  font-weight: bold;
                ">
                <!-- {{item}} -->
                {{ item.moduleName }}
              </div>
              <div class="boxx" v-for="(subItem, index) in moduleTableDownloadMap[
                  item.moduleCode
                ]" :key="subItem.name" @click="
                  subItem.fileName
                    ? down(item)
                    : goDetail(subItem.contentCode, item.moduleName)
                " v-show="
                  ((moduleTableDownloadMap[item.moduleCode].length > 1 ||
                    item.moduleClass != 'announce') &&
                    item.moduleClass != 'news' &&
                    index < 5) ||
                  open
                ">
                {{ subItem.fileName || subItem.contentTitle }}
                <div class="down-btn" @click="down(subItem)" v-if="
                    subItem.fileName &&
                    (moduleTableDownloadMap[item.moduleCode].length > 1 ||
                      item.moduleClass != 'announce')
                  ">
                  <img src="../../../assets/images/icon_visa_japan_down.png" />
                  下载
                </div>
                <span style="float: right" v-if="
                    moduleTableDownloadMap[item.moduleCode].length > 1 ||
                    item.moduleClass != 'announce'
                  ">{{ String(subItem.createTime).split(" ")[0] }}</span>
                <a-divider dashed style="margin: 1px 0 1px 0" v-if="
                    moduleTableDownloadMap[item.moduleCode].length > 1 ||
                    item.moduleClass != 'announce'
                  " />
              </div>

              <div v-if="
                  (moduleTableDownloadMap[item.moduleCode].length == 1 &&
                    item.moduleClass == 'announce') ||
                  item.moduleClass == 'news'
                " v-html="moduleTableDownloadMap[item.moduleCode].contentHtml" class="hover-box design-html" v-bind:style="{
                  '--beforeLeft': 143 + 'px',
                  '--afterLeft': 142 + 'px',
                }"></div>

            </div>
            <div class="more" v-if="
                !open &&
                (moduleTableDownloadMap[item.moduleCode].length > 1 ||
                  item.moduleClass != 'announce')&&item.moduleClass != 'news'
              " @click="navDetailByModuleCode('表格下载', item)">
              显示更多
              <a-icon type="down" style="color: #cab484" />
            </div>
            <div class="more" v-if="
                (moduleTableDownloadMap[item.moduleCode].length == 1 &&
                item.moduleClass == 'announce') ||item.moduleClass == 'news'
              " @click="
                navDetailByContentCode(
                  '表格下载',
                  item,
                  moduleTableDownloadMap[item.moduleCode][0]
                )
              ">
              显示更多
              <a-icon type="down" style="color: #cab484" />
            </div>
          </div>
        </div>
      </div>
      <div class="box" @mouseleave.stop="mouseout">
        <div class="box-item">
          <img src="../../../assets/images/icon_visa_need_stuff.png" />
          <p>{{resource["RES1D9C0938AAC0230"]}}</p>
          <div class="item-item">
            <p>
              <span v-for="item in needMaterialInfo" :key="item.moduleCode" style="margin: 0 0.3em" @click="navDetailByModuleCode('所需材料', item)" @mouseenter="mouseOver(item, '730px', true)">{{ item.moduleName }}</span>
            </p>
          </div>
        </div>
        <div v-for="item in needMaterialInfo" :key="item.moduleCode">
          <div class="hover-content hover-content-middle hover-materuals" v-if="mouseModuleCode === item.moduleCode" ref="visit-relatives-friends">
            <div class="subtitle hover-box-center" style="
                font-size: 20px;
                padding-bottom: 10px;
                padding-left: 23px;
                font-weight: bold;
                text-align: left;
              ">
              {{ item.moduleName }}
            </div>
            <div class="hover-list" v-for="(subItem, index) in moduleNeedMaterialMap[item.moduleCode]" :key="subItem.contentTitle" @click="goDetail(subItem.contentCode, item.moduleName)" v-show="index < 5">
              <div class="item-left">
                {{ subItem.contentTitle }}
                <span style="float: right">{{
                  String(subItem.createTime).split(" ")[0]
                }}</span>
              </div>

              <a-divider dashed style="margin: 10px 0 32px 0" />
            </div>
            <div class="more" v-if="!open" @click="navDetailByModuleCode('所需材料', item)">
              显示更多
              <a-icon type="down" style="color: #cab484" />
            </div>
          </div>
        </div>
      </div>
      <div class="box" @mouseleave.stop="mouseout" style="clear: both">
        <div class="box-item">
          <img src="../../../assets/images/icon_visa_handle_flow.png" />
          <p>{{resource["RESB39E78FBDFEF4C1"]}}</p>
          <div class="item-item">
            <p style="font-size: 16px;
                font-weight: normal;
                font-family: Microsoft YaHei;
                cursor: default;
              ">
              <span v-for="item in sortProcessInfo" :key="item.moduleCode" style="margin: 0 5px" @click="goDetail(item.contentCode,'办理流程')" @mouseenter="mouseOver(item, '730px', true)">{{ item.moduleName }}</span>
            </p>
          </div>
        </div>
        <div v-for="item in sortProcessInfo" :key="item.moduleCode">
          <div class="hover-content hover-content-process hover-flow" v-if="mouseModuleCode === item.moduleCode" style="height: 470px">
            <div class="hover-box hover-box-process" v-html="moduleSortProcessMap[item.contentCode]"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadFile } from "@/api/file.js";
import {
  getModuleInfo,
  getModuleChild,
  getInfoByGet,
  getResource
} from "@/api/moduleContent";
import { pushModuleAnnounceHtmlContent } from "../../../util/navUtils";
import { pushContentAnnounceHtmlContent } from "../../../util/navUtils";

export default {
  name: "hover-box",
  data () {
    return {
      curHeight: "260px",
      open: false,
      mouseModuleCode: "",
      mouseModuleItem: null,
      tableDownloadInfo: [],
      moduleTableDownloadMap: {},
      needMaterialInfo: [],
      moduleNeedMaterialMap: {},
      sortProcessInfo: [],
      moduleSortProcessMap: {},
      resource: {}
    };
  },
  created () {
    this.getResource()
    this.getTableDownload();
    this.getNeedMaterial();
    this.getSortProcess();
  },
  methods: {
    getResource () {
      getResource("RESB640F0E2C6CDFA9").then(res => {
        res.data.records && res.data.records.forEach(e => {
          // 办理流程
          if (e.resourceCode === "RESB39E78FBDFEF4C1") {
            this.resource["RESB39E78FBDFEF4C1"] = e.resourceName
          }
          // 表格下载
          if (e.resourceCode === "RES94443CB61B253F3") {
            this.resource["RES94443CB61B253F3"] = e.resourceName
          }
          // 所需材料
          if (e.resourceCode === "RES1D9C0938AAC0230") {
            this.resource["RES1D9C0938AAC0230"] = e.resourceName
          }
        })
        console.log("this.resource", this.resource)
      })
    },
    navDetailByContentCode (parentName, moduleItem, subItem) {
      let contentType = "contentAnnounce";
      if (moduleItem.moduleClass === "news") {
        contentType = "contentNews";
      }
      let linkname = `出国签证/${parentName}/${moduleItem.moduleName}`;
      // this.pushRouter(`/selfComponents?name=${parentName}&linkname=${linkname}&type=4`)
      pushContentAnnounceHtmlContent(
        this,
        subItem.contentCode,
        moduleItem.moduleName,
        linkname,
        contentType
      );
    },
    getTableDownload () {
      let sign = [];
      getModuleInfo("RES94443CB61B253F3")
        .then((res) => {
          this.tableDownloadInfo = [];
          const tableDownloadChildArr = res.data.records.map((item) => {
            sign.push(item);
            this.tableDownloadInfo.push({ ...item });
            if (item.moduleClass == "contentdownload") {
              return getModuleChild(item.moduleCode, "contentDownload");
            } else if (item.moduleClass == "news") {
              return getModuleChild(item.moduleCode, "contentNews");
            } else {
              return getModuleChild(item.moduleCode, "contentAnnounce");
            }
          });
          return Promise.all(tableDownloadChildArr);
        })
        .then((arr) => {
          console.log(sign, "++++++++++++++++");
          arr.map((item) => {
            console.log(item.data);
            this.moduleTableDownloadMap[item.params.moduleCode] =
              item.data.records;
            console.log(this.moduleTableDownloadMap, "=====+++");
          });
          sign.forEach((e) => {
            if (
              e.moduleClass == "announce" &&
              this.moduleTableDownloadMap[e.moduleCode].length == 1
            ) {
              console.log(
                this.moduleTableDownloadMap[e.moduleCode][0].contentCode
              );
              getInfoByGet(
                this.moduleTableDownloadMap[e.moduleCode][0].contentCode
              ).then((res) => {
                this.moduleTableDownloadMap[e.moduleCode]["contentHtml"] =
                  "<div>" + res.data.contentHtml + "</div>";
              });
            }
            if (e.moduleClass == "news") {
              getInfoByGet(
                this.moduleTableDownloadMap[e.moduleCode][0].contentCode,
                "contentNews"
              ).then((res) => {
                this.moduleTableDownloadMap[e.moduleCode]["contentHtml"] =
                  "<div>" + res.data.contentHtml + "</div>";
              });
            }
          });
        });
    },

    getNeedMaterial () {
      getModuleInfo("RES1D9C0938AAC0230")
        .then((res) => {
          this.needMaterialInfo = [];
          const needMaterialChildArr = res.data.records.map((item) => {
            this.needMaterialInfo.push({ ...item });
            return getModuleChild(item.moduleCode, "contentAnnounce");
          });
          return Promise.all(needMaterialChildArr);
        })
        .then((arr) => {
          arr.map((item) => {
            this.moduleNeedMaterialMap[item.params.moduleCode] =
              item.data.records;
          });
        });
    },

    getSortProcess () {
      getModuleInfo("RESB39E78FBDFEF4C1")
        .then((res) => {
          this.sortProcessInfo = [];
          let sortProcessChildArr = res.data.records.map((item) => {
            this.sortProcessInfo.push({ ...item });
            return getModuleChild(item.moduleCode, "contentAnnounce");
          });
          return Promise.all(sortProcessChildArr);
        })
        .then((arr) => {
          const sortProcessChildInfoArr = arr.map((item) => {
            const { contentCode, moduleCode } = item.data.records[0];
            this.sortProcessInfo.forEach((val) => {
              if (val.moduleCode === moduleCode) {
                val["contentCode"] = contentCode;
              }
            });
            return getInfoByGet(contentCode);
          });
          return Promise.all(sortProcessChildInfoArr);
        })
        .then((datas) => {
          for (let index in datas) {
            const { contentHtml, contentCode, contentTitle } =
              datas[index].data;
            this.sortProcessInfo.forEach((val) => {
              if (val.contentCode === contentCode) {
                val["contentTitle"] = contentTitle;
              }
            });
            this.moduleSortProcessMap[contentCode] = contentHtml;
          }
        });
    },
    showMore (type) {
      this.open = !this.open;
    },

    navDetailByModuleCode (parentName, moduleItem) {
      console.log(parentName, moduleItem);
      let contentType = "contentAnnounce";
      if (moduleItem.moduleClass === "contentdownload") {
        contentType = "contentDownload";
      }
      let linkname = `出国签证/${parentName}/${moduleItem.moduleName}`;
      pushModuleAnnounceHtmlContent(
        this,
        moduleItem.moduleCode,
        moduleItem.moduleName,
        linkname,
        contentType
      );
    },
    goDetail (contentCode, name) {
      const type = "contentAnnounce";
      this.pushRouter(
        `/guide?contentCode=${contentCode}&type=${type}&linkname=出国签证/${name}/详情`
      );
    },
    down (i) {
      let baseUrl =
        process.env.NODE_ENV === "development"
          ? "http://10.11.0.104:55000"
          : "http://10.10.152.115:55000";
      downloadFile(
        `/api/cloud-fastdfs/fastdfs/download/file/${i.tenantCode}/${i.appCode}?fileCode=${i.fileCode}`,
        i.fileName
      );
    },
    // 移入
    mouseOver (moduleItem, height, bool = false) {
      this.curHeight = bool ? height : "830px";
      this.mouseModuleCode = moduleItem.moduleCode;
      this.mouseModuleItem = moduleItem;
      this.open = false;
    },
    // 移出
    mouseout () {
      this.curHeight = "260px";
      this.mouseModuleCode = "";
      this.mouseModuleItem = null;
      this.open = false;
    },
  },
};
</script>


<style lang="less" scoped>
.hover-list {
  width: 98%;
  font-size: 16px;
  height: 58px;
  padding-left: 50px;
  word-break: break-all;
  position: relative;

  .item-left {
    text-align: left;
    padding-top: 20px;
  }

  & > div:nth-of-type(1) {
    width: 100%;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
  }

  & > div:nth-of-type(1):hover {
    color: #cbb486;
  }
}

/deep/.hover-content {
  /* flex-wrap: wrap; */
  width: 1140px;
  /* height: 496px; */
  height: 530px;
  overflow: hidden;
  position: absolute;
  top: 281px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  padding: 48px;
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);

  .hover-list1 {
    width: 100%;
    font-size: 20px;
    margin-bottom: 25px;
    padding-left: 20px;

    & > div:nth-of-type(1) {
      width: 100%;
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      cursor: pointer;
    }
  }

  .hover-list1::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #cbb486;
    border-radius: 50%;
    transform: translate(-10px, -10px);
  }
}
</style>
<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
  margin-bottom: 40px;

  &-box {
    width: 1140px;
    // position: absolute;
    // left: 50%;
    // transform: translateX(-50%);
    position: relative;
    margin: auto;
    text-align: left;
    font-size: 0px;
  }
}
.design-html img {
  width: 100%;
}
.box:not(:last-of-type) {
  margin-right: 45px;
}

.box:hover {
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}

.box-item .item-item {
  height: 30px;

  p {
    font-size: 16px;
    font-weight: normal;
    font-family: Microsoft YaHei;
    margin-top: 25px;

    span {
      padding: 0 -1px;
      cursor: pointer;
      color: #7f7f7f;
    }

    span:hover {
      color: #e4cba4;
    }

    .Space:after {
      content: "\00a0";
    }
  }
}

.box {
  width: 350px;
  height: 260px;
  display: inline-block;
  border: 1px solid #e5e5e5;
  text-align: center;

  position: relative;

  .box-item {
    position: relative;
    top: 22px;
    width: 350px;
    height: 260px;
  }

  img {
    width: 64px;
    height: 64px;
    margin-top: 29px;
  }

  p {
    margin: 0;
    padding: 0;
    font-size: 20px;
    font-weight: bold;
    color: #000000;
    margin-top: 36px;
  }

  .box-item-thirdly {
    font-size: 16px;
  }

  .box-item > p:first-of-type {
    // width: 4em;
    margin: 0 auto;
    margin-top: 36px;
    cursor: pointer;
    font-family: Microsoft YaHei;
  }
}

.hover-content {
  width: 1140px;
  /* height: 530px; */
  height: 530px;
  overflow: hidden;
  position: absolute;
  top: 280px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}
.hover-download {
  height: 470px;
}
.hover-materuals {
  height: 470px;
}
/deep/.hover-flow {
  height: 410px;
}
.hover-content.hover-content-process {
  left: -791px;
}

.hover-content.hover-content-middle {
  left: -395px;
}

.hover-content-middle {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: absolute;
}

.hover-list::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #cbb486;
  border-radius: 50%;
  position: absolute;
  left: 25px;
  top: 28px;
}

//.hover-content.hover-content-list {
//  height: 400px;
//}
.hover-box {
  flex: 1;
  text-align: left;

  p {
    padding: 0;
    margin: 0;
    margin-top: 20px;
    padding-bottom: 15px;
  }

  .boxx:hover {
    color: #cbb486;
  }

  div:hover .down-btn {
    display: inline-block;
  }

  .boxx {
    margin: 0;
    padding: 0;
    font-size: 16px;
    cursor: pointer;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3d4652;
    line-height: 56px;
    // border-bottom: 2px dotted #eee;
    padding-left: 50px;
    position: relative;
    white-space: nowrap;

    .down-btn {
      line-height: 28px;
      color: #cbb486;
    }

    img {
      line-height: 36px;
      margin-top: 0px;
    }
  }

  .boxx::before {
    //圆点
    content: "";
    display: inline-block;
    border-radius: 50%;
    width: 5px;
    height: 5px;
    background: rgba(203, 180, 134, 1);
    position: absolute;
    left: 25px;
    top: 26px;
  }
}

.subtitle:hover {
  color: #000 !important;
}
.hover-box:first-of-type {
  margin-right: 40px;
}

.hover-box:nth-of-type(2) {
  margin-right: 40px;
}

.down-btn {
  display: inline-block;
  display: none;
  width: 80px;
  height: 30px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid #cbb486;
  vertical-align: middle;
  text-align: center;

  img {
    width: 16px;
    height: 16px;
  }
}

.hover-box::before {
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  top: -16px;
  //left: 143px;
  left: var(--beforeLeft);
  padding: 0;
  border-bottom: 8px solid #ffffff;
  border-top: 8px solid transparent;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  display: block;
  content: "";
  z-index: 12;
}

.hover-box::after {
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  top: -18px;
  //left: 142px;
  left: var(--afterLeft);
  padding: 0;
  border-bottom: 9px dotted #cbb486;
  border-top: 9px solid transparent;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  display: block;
  content: "";
  z-index: 10;
}

.hover-box.hover-box-process::before {
  left: 955px;
}

.hover-box.hover-box-process::after {
  left: 954px;
}
// .hover-box.hover-box-center::before {
//   left: 559px;
// }

// .hover-box.hover-box-center::after {
//   left: 558px;
// }
.hover-box.hover-box-process img {
  margin: 0;
  width: 100%;
  height: 100%;
}

.hover-box-middle {
  min-height: 252px;
}

.hover-box.hover-box-middle::before {
  left: 575px;
}

.hover-box.hover-box-middle::after {
  left: 574px;
}

.more {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #cab484;
  position: absolute;
  display: block;
  height: 70px;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  background: white;
  width: 100%;
  line-height: 70px;
  text-align: center;
  // opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/home/goaboard/siderContent-02.vue